import React from "react";
import { MainDiv } from "../../components/Profile/Profile.style";
import { VolunteerHeading } from "../../components/Volunteer/Volunteer.style";
import useProfile from "../../hooks/useProfile";
import VolunteersFromWebTable from "./VolunteersFromWebTable";

const VolunteersFromWebPage = () => {
  const [userData, isLoading] = useProfile();
  if (isLoading) {
    return "";
  }
  const user = userData.ugleve_name;
  return (
    <MainDiv>
      <VolunteerHeading>Volunteers List</VolunteerHeading>
      <VolunteersFromWebTable></VolunteersFromWebTable>
      {/* <Profile /> */}
    </MainDiv>
  );
};

export default VolunteersFromWebPage;
